<template>
  <div class="appManagement">
    <div class="ac_left" v-if="!user.is_table && routePath != '/appManagement' && !['pptMode'].includes($store.state.mode)">
      <img
        class="leftToolBackground"
        src="@/assets/img/appCenter/leftToolBackground.png"
      />
      <!-- <div class="find">
				<img src="../../assets/img/appCenter/appManagement/find_icon.svg" />
				<span>{{ lang.discovery }}</span>
			</div> -->
      <saveCard
        :title="lang.RecentUse"
        :data="recentUse"
        :icon="
          require('../../assets/img/appCenter/appManagement/history2_icon.svg')
        "
        :type="1"
        @saveClick="openApp"
      />
      <saveCard
        :title="lang.myCollection"
        :icon="
          require('../../assets/img/appCenter/appManagement/collect2_icon.svg')
        "
        :data="collect"
        :type="0"
        @saveClick="openApp"
      />
    </div>
    <div class="ac_right">
      <div class="ac_header">
        <!-- <el-button
					type="primary"
					size="small"
					icon="el-icon-plus"
					v-show="false"
					style="position: absolute; right: 15px"
					@click="addApp"
					>添加应用</el-button
				> -->
        <div
          class="ac_h_banner"
          v-if="communityList.length && !['pptMode'].includes($store.state.mode)"
        >
          <el-carousel :interval="5000" arrow="hover" height="25vh">
            <el-carousel-item
              v-for="(item, index) in communityList"
              :key="index"
            >
              <img
                class="bannerImage"
                :src="item.banner"
                alt="banner"
                v-if="item.banner"
                style="cursor:pointer"
                @click="clickCyBanner(item)"
              />
              <div v-else class="cyban" @click="clickCyBanner(item)">
                {{ item.name?item.name:'' }}
              </div>
            </el-carousel-item>
          </el-carousel>
        </div>
        <!-- <div
          class="ac_h_banner"
          v-else-if="controlsObj && controlsObj.bannerUrlList"
        >
          <el-carousel :interval="5000" arrow="hover" height="25vh">
            <el-carousel-item
              v-for="(item, index) in controlsObj.bannerUrlList"
              :key="index"
            >
              <img
                class="bannerImage"
                :src="item.url"
                alt="banner"
                :style="item.path || item.http ? `cursor:pointer` : ``"
                @click="clickBanner(item)"
              />
            </el-carousel-item>
          </el-carousel>
        </div> -->
        <div
          class="ac_h_banner"
          v-else-if="controlsObj && controlsObj.bannerUrl && !['pptMode'].includes($store.state.mode)"
        >
          <img :src="controlsObj.bannerUrl" alt="banner" />
        </div>
        <div class="ac_h_bottom">
          <div class="ac_h_b_selectList">
            <div>
              <el-select
                v-model="selectJuri"
                :placeholder="lang.select_display_range"
                @change="changeSelectType"
                style="width: 120px; margin-right: 10px"
              >
                <el-option
                  v-for="item in selectList"
                  :key="item.index"
                  :label="item.label"
                  :value="item.index"
                ></el-option>
              </el-select>
              <el-select
                v-model="selectLabel"
                :placeholder="lang.select_type"
                @change="changeSelectType"
                style="width: 110px; margin-right: 10px"
              >
                <el-option
                  v-for="item in labelSelect"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>

              <el-select
                v-model="selectModel"
                :placeholder="lang.selectionMode"
                @change="changeSelectType"
                style="width: 110px; margin-right: 10px"
              >
                <el-option
                  v-for="item in modelList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>

              <!--<el-select
                v-model="selectTag"
                @change="changeSelectTag"
                style="width: 110px; margin-right: 10px"
              >
                <template v-for="item in tagList">
                  <el-option
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </template>
              </el-select>-->

              <el-select
                v-model="selectSort"
                @change="changeSelectSort"
                style="width: 110px; margin-right: 10px"
              >
                <template>
                  <el-option
                    v-for="item in sortList"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </template>
              </el-select>

              <!-- <el-select
								v-model="statusType"
								:placeholder="lang.select_status"
								@change="changeSelectType"
								style="width: 110px; margin-right: 10px"
							>
								<el-option
									v-for="item in statusList"
									:key="item.value"
									:label="item.label"
									:value="item.value"
								></el-option>
							</el-select> -->
            </div>

            <div>
              <el-input
                v-model="searchText"
                style="width: 325px"
                :placeholder="lang.input_app_name"
                @keyup.enter.native="getData"
              >
                <i
                  slot="suffix"
                  class="searchInputIcon el-icon-search"
                  @click="getData"
                ></i>
              </el-input>
              <!-- <el-button
              type="primary"
              style="margin-left: 10px;"
              icon="el-icon-search"
              @click="getData"
            ></el-button> -->
              <!-- <el-button type="primary" @click="selectApp()">{{
								lang.publish_app
							}}</el-button> -->
            </div>
          </div>

          <div class="ac_h_b_typeList">
            <span
              :class="{ ac_h_b_typeList_active: showType === '' }"
              @click="changeType('')"
              >{{ lang.all }}</span
            >
            <span
              v-for="item in typeList"
              :key="item.id"
              :class="{ ac_h_b_typeList_active: showType === item.id }"
              @click="changeType(item.id)"
              >{{ item.name }}</span
            >
          </div>
        </div>
      </div>

      <div class="ac_content" v-loading="getDataLoading">
        <template v-if="showType !== '' && !getDataLoading">
          <div class="ac_c_tc_i_top">
            <div>{{ typeList.find((i) => i.id === showType)?typeList.find((i) => i.id === showType).name:"" }}</div>

            <!-- <span
							>
							<div>{{ lang.view_more }}</div>
						</span> -->
          </div>
          <div>
            <div
              :class="{
                comItem: user.orgArea == 'com',
                tableClass: !user.is_table,
                ac_c_item: user.is_table && user.orgArea != 'com',
              }"
              v-for="item in dataList"
              :key="item.id"
              @click="openApp(item)"
            >
              <div class="ac_c_i_top2">
                <div class="ac_c_i_t2_left">
                  <div class="ac_c_i_t2_l_avatarArea">
                    <img v-if="item.json.icon" :src="item.json.icon" />
                    <svg
                      v-else
                      t="1732605901531"
                      class="icon"
                      viewBox="0 0 1024 1024"
                      version="1.1"
                      xmlns="http://www.w3.org/2000/svg"
                      p-id="4275"
                      width="200"
                      height="200"
                    >
                      <path
                        d="M179.2 153.6a51.2 51.2 0 0 0-51.2 51.2v128a51.2 51.2 0 0 0 51.2 51.2h128a51.2 51.2 0 0 0 51.2-51.2V204.8a51.2 51.2 0 0 0-51.2-51.2H179.2z m0-102.4h128a153.6 153.6 0 0 1 153.6 153.6v128a153.6 153.6 0 0 1-153.6 153.6H179.2a153.6 153.6 0 0 1-153.6-153.6V204.8a153.6 153.6 0 0 1 153.6-153.6z m0 614.4a51.2 51.2 0 0 0-51.2 51.2v128a51.2 51.2 0 0 0 51.2 51.2h128a51.2 51.2 0 0 0 51.2-51.2V716.8a51.2 51.2 0 0 0-51.2-51.2H179.2z m0-102.4h128a153.6 153.6 0 0 1 153.6 153.6v128a153.6 153.6 0 0 1-153.6 153.6H179.2a153.6 153.6 0 0 1-153.6-153.6V716.8a153.6 153.6 0 0 1 153.6-153.6z m611.84-403.4048a51.2 51.2 0 0 0-72.3968 0L646.144 232.2432a51.2 51.2 0 0 0 0 72.3968l72.448 72.3968a51.2 51.2 0 0 0 72.3968 0l72.3968-72.3968a51.2 51.2 0 0 0 0-72.3968L791.04 159.744z m72.3968-72.3968l72.3968 72.3968a153.6 153.6 0 0 1 0 217.2416l-72.3968 72.3968a153.6 153.6 0 0 1-217.2416 0l-72.3968-72.3968a153.6 153.6 0 0 1 0-217.2416l72.3968-72.3968a153.6 153.6 0 0 1 217.2416 0zM699.7504 896a51.2 51.2 0 0 1 0 102.4A162.1504 162.1504 0 0 1 537.6 836.2496v-110.8992A162.1504 162.1504 0 0 1 699.7504 563.2h110.8992a162.1504 162.1504 0 0 1 162.1504 162.1504v8.448a51.2 51.2 0 0 1-102.4 0v-8.448c0-33.024-26.7264-59.7504-59.7504-59.7504h-110.8992c-33.024 0-59.7504 26.7264-59.7504 59.7504v110.8992c0 33.024 26.7264 59.7504 59.7504 59.7504z"
                        fill="#2C6DD2"
                        p-id="4276"
                      ></path>
                      <path
                        d="M791.4496 160a51.2 51.2 0 0 0-72.3968 0l-72.448 72.3968a51.2 51.2 0 0 0 0 72.3968l72.448 72.3968a51.2 51.2 0 0 0 72.3968 0l72.3968-72.3968a51.2 51.2 0 0 0 0-72.3968l-72.3968-72.3968z"
                        fill="#20C997"
                        p-id="4277"
                      ></path>
                    </svg>
                  </div>
                </div>
                <div class="ac_c_i_t2_right">
                  <div class="ac_c_i_t2_r_top">
                    <el-tooltip
                      class="item"
                      effect="light"
                      :content="item.name"
                      placement="top"
                    >
                      <span>{{ item.name }}</span>
                    </el-tooltip>

                    <div class="ac_c_i_t_popover" v-if="showMenu(item)">
                      <div
                        class="ac_c_i_t_p_box"
                        v-if="editAppCard === item.id"
                        v-click-outside="handleBlur"
                      >
                        <div
                          @click.stop="copyApp(item)"
                          v-if="item.json && item.json.copy === '1'"
                        >
                          <img
                            src="../../assets/img/appCenter/appManagement/copy.svg"
                            alt=""
                          />
                          <span>{{ lang.fz }}</span>
                        </div>
                        <div
                          @click.stop="updateApp(item)"
                          v-if="item.userid === user.userId"
                        >
                          <img
                            src="../../assets/img/appCenter/appManagement/edit.svg"
                            alt=""
                          />
                          <span>{{ lang.modifying_agents }}</span>
                        </div>
                        <div
                          @click.stop="delApp(item)"
                          v-if="item.userid === user.userId"
                        >
                          <img
                            src="../../assets/img/appCenter/appManagement/del.svg"
                            alt=""
                          />
                          <span>{{ lang.unpublish }}</span>
                        </div>
                      </div>
                      <svg
                        t="1732786015570"
                        @click.stop="updateCard(item.id)"
                        :style="`transform: rotate(${
                          editAppCard === item.id ? '90deg' : '0deg'
                        });background-color:${
                          editAppCard === item.id ? '#F3F7FD' : '#fff'
                        }`"
                        class="icon"
                        viewBox="0 0 1024 1024"
                        version="1.1"
                        xmlns="http://www.w3.org/2000/svg"
                        p-id="9199"
                        width="200"
                        height="200"
                      >
                        <path
                          d="M192 443.733333c-38.4 0-68.266667 29.866667-68.266667 68.266667 0 38.4 29.866667 68.266667 68.266667 68.266667s68.266667-29.866667 68.266667-68.266667c0-38.4-29.866667-68.266667-68.266667-68.266667zM512 443.733333c-38.4 0-68.266667 29.866667-68.266667 68.266667 0 38.4 29.866667 68.266667 68.266667 68.266667s68.266667-29.866667 68.266667-68.266667c0-38.4-29.866667-68.266667-68.266667-68.266667zM832 443.733333c-38.4 0-68.266667 29.866667-68.266667 68.266667 0 38.4 29.866667 68.266667 68.266667 68.266667s68.266667-29.866667 68.266667-68.266667c0-38.4-34.133333-68.266667-68.266667-68.266667z"
                          fill="#111111"
                          p-id="9200"
                        ></path>
                      </svg>
                    </div>
                  </div>
                  <div class="ac_c_i_t2_r_center">
                    <span>{{ item.username }}</span>
                    <span>@{{ item.orgName }}</span>
                  </div>
                  <div class="ac_c_i_t2_r_bottom">
                    <span v-if="['agent', 'workflow'].includes(item.label)">{{
                      labelSelect.find((i) => i.value === item.label).label
                    }}</span>
                    <span
                      v-if="
                        ['agent'].includes(item.label) ||
                        (['workflow'].includes(item.label) && item.json.modes)
                      "
                    >
                      <template v-if="item.label === 'agent'">{{
                        lang.chatMode
                      }}</template>
                      <template v-else-if="item.json.modes">{{
                        wayList[item.json.modes[0]]
                      }}</template>
                    </span>
                    <span v-if="item.tag">
                      <img
                        v-if="item.tag == '1'"
                        src="@/assets/img/appCenter/appManagement/authority_icon.svg"
                        alt=""
                      />
                      <img
                        v-if="item.tag == '2'"
                        src="@/assets/img/appCenter/appManagement/winnow_icon.svg"
                        alt=""
                      />
                      <img
                        v-if="item.tag == '3'"
                        src="@/assets/img/appCenter/appManagement/exclusive_icon.svg"
                        alt=""
                      />

                      <template v-if="item.tag == '1'">{{
                        lang.authority
                      }}</template>
                      <template v-if="item.tag == '2'">{{
                        lang.winnow
                      }}</template>
                      <template v-if="item.tag == '3'">{{
                        lang.exclusive
                      }}</template>
                      <template v-if="item.tag == '4'">{{
                        lang.organization
                      }}</template>
                      <template v-if="item.tag == '5'">{{
                        lang.personal
                      }}</template>
                    </span>
                    <span v-if="item.json.cyid">
                      <el-tooltip class="item" effect="dark" :content="cyname(item.json.cyid)" placement="top">
                          <p>{{lang.community}}</p>
                      </el-tooltip>
                    </span>
                  </div>
                </div>
              </div>
              <div class="ac_c_i_center2">
                <div>
                  {{ item.detail }}
                </div>
              </div>
              <div class="ac_c_i_bottom2" @click.stop="">
                <el-tooltip
                  class="item"
                  effect="light"
                  :content="lang.number_of_users"
                  placement="top"
                >
                  <div @click.stop="">
                    <img
                      src="../../assets/img/appCenter/appManagement/user_copy.svg"
                    />
                    <span>{{ item.useCount }}</span>
                  </div>
                </el-tooltip>
                <span></span>
                <el-tooltip
                  class="item"
                  effect="light"
                  :content="item.likeId ? lang.unlike : lang.isLike"
                  placement="top"
                >
                  <div @click.stop="praiseFn(item, !item.likeId ? 0 : 1)">
                    <img
                      :src="
                        require('@/assets/img/appCenter/appManagement/like_icon.svg')
                      "
                      v-if="!item.likeId"
                      style="cursor: pointer"
                    />
                    <img
                      :src="
                        require('@/assets/img/appCenter/appManagement/isLike_icon.svg')
                      "
                      v-else
                      style="cursor: pointer"
                    />
                    <span>{{ item.likeCount }}</span>
                  </div>
                </el-tooltip>
                <span></span>
                <el-tooltip
                  class="item"
                  effect="light"
                  :content="item.collectId ? lang.cancel_collect : lang.collect"
                  placement="top"
                >
                  <div @click.stop="collectFn(item, !item.collectId ? 0 : 1)">
                    <img
                      src="../../assets/img/appCenter/appManagement/collect_default.svg"
                      v-if="!item.collectId"
                      style="cursor: pointer"
                    />
                    <img
                      src="../../assets/img/appCenter/appManagement/collect_active.svg"
                      v-else
                      style="cursor: pointer"
                    />
                    <span>{{ item.collectCount }}</span>
                  </div>
                </el-tooltip>
              </div>
            </div>
          </div>
        </template>

        <div class="ac_c_typeCard" v-if="showType == '' && dataList.length > 0">
          <!-- v-if="dataList.filter((i) => i.type == item2.id).length === 0" -->
          <template v-for="(item2, index2) in typeList">
            <div
              class="ac_c_tc_item"
              v-if="dataList.filter((i) => i.type == item2.id).length > 0"
              :key="index2 + '-' + item2.id"
            >
              <div class="ac_c_tc_i_top">
                <div>{{ item2.name }}</div>

                <span
                  @click="changeType(item2.id)"
                  v-if="
                    dataList.filter((i) => i.type == item2.id).length >
                    showCardNum(
                      dataList.filter((i) => i.type == item2.id).length
                    )
                  "
                  ><div>{{ lang.view_more }}</div>
                  <!-- <svg t="1741157880921" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="3440" width="200" height="200"><path d="M276.755 942.936c28.497 29.315 74.739 29.315 103.307 0l367.236-378.011c28.483-29.367 28.483-76.982 0-106.291l-367.236-377.997c-28.562-29.367-74.806-29.367-103.307 0-28.546 29.325-28.546 76.929 0 106.304l315.6 324.841-315.599 324.803c-28.545 29.367-28.544 76.973 0 106.356l0 0z" fill="#A2A2A2" p-id="3441"></path></svg> -->
                </span>
              </div>
              <div class="ac_c_tc_i_bottom">
                <template
                  v-for="(item, index) in dataList.filter(
                    (i) => i.type == item2.id
                  )"
                >
                  <div
                    :class="{
                      comItem: user.orgArea == 'com',
                      tableClass: !user.is_table,
                      ac_c_item: user.is_table && user.orgArea != 'com',
                    }"
                    v-if="
                      index <
                      showCardNum(
                        dataList.filter((i) => i.type == item2.id).length
                      )
                    "
                    :key="item.id"
                    @click="openApp(item)"
                  >
                    <div class="ac_c_i_top2">
                      <div class="ac_c_i_t2_left">
                        <div class="ac_c_i_t2_l_avatarArea">
                          <img v-if="item.json.icon" :src="item.json.icon" />
                          <svg
                            v-else
                            t="1732605901531"
                            class="icon"
                            viewBox="0 0 1024 1024"
                            version="1.1"
                            xmlns="http://www.w3.org/2000/svg"
                            p-id="4275"
                            width="200"
                            height="200"
                          >
                            <path
                              d="M179.2 153.6a51.2 51.2 0 0 0-51.2 51.2v128a51.2 51.2 0 0 0 51.2 51.2h128a51.2 51.2 0 0 0 51.2-51.2V204.8a51.2 51.2 0 0 0-51.2-51.2H179.2z m0-102.4h128a153.6 153.6 0 0 1 153.6 153.6v128a153.6 153.6 0 0 1-153.6 153.6H179.2a153.6 153.6 0 0 1-153.6-153.6V204.8a153.6 153.6 0 0 1 153.6-153.6z m0 614.4a51.2 51.2 0 0 0-51.2 51.2v128a51.2 51.2 0 0 0 51.2 51.2h128a51.2 51.2 0 0 0 51.2-51.2V716.8a51.2 51.2 0 0 0-51.2-51.2H179.2z m0-102.4h128a153.6 153.6 0 0 1 153.6 153.6v128a153.6 153.6 0 0 1-153.6 153.6H179.2a153.6 153.6 0 0 1-153.6-153.6V716.8a153.6 153.6 0 0 1 153.6-153.6z m611.84-403.4048a51.2 51.2 0 0 0-72.3968 0L646.144 232.2432a51.2 51.2 0 0 0 0 72.3968l72.448 72.3968a51.2 51.2 0 0 0 72.3968 0l72.3968-72.3968a51.2 51.2 0 0 0 0-72.3968L791.04 159.744z m72.3968-72.3968l72.3968 72.3968a153.6 153.6 0 0 1 0 217.2416l-72.3968 72.3968a153.6 153.6 0 0 1-217.2416 0l-72.3968-72.3968a153.6 153.6 0 0 1 0-217.2416l72.3968-72.3968a153.6 153.6 0 0 1 217.2416 0zM699.7504 896a51.2 51.2 0 0 1 0 102.4A162.1504 162.1504 0 0 1 537.6 836.2496v-110.8992A162.1504 162.1504 0 0 1 699.7504 563.2h110.8992a162.1504 162.1504 0 0 1 162.1504 162.1504v8.448a51.2 51.2 0 0 1-102.4 0v-8.448c0-33.024-26.7264-59.7504-59.7504-59.7504h-110.8992c-33.024 0-59.7504 26.7264-59.7504 59.7504v110.8992c0 33.024 26.7264 59.7504 59.7504 59.7504z"
                              fill="#2C6DD2"
                              p-id="4276"
                            ></path>
                            <path
                              d="M791.4496 160a51.2 51.2 0 0 0-72.3968 0l-72.448 72.3968a51.2 51.2 0 0 0 0 72.3968l72.448 72.3968a51.2 51.2 0 0 0 72.3968 0l72.3968-72.3968a51.2 51.2 0 0 0 0-72.3968l-72.3968-72.3968z"
                              fill="#20C997"
                              p-id="4277"
                            ></path>
                          </svg>
                        </div>
                      </div>
                      <div class="ac_c_i_t2_right">
                        <div class="ac_c_i_t2_r_top">
                          <el-tooltip
                            class="item"
                            effect="light"
                            :content="item.name"
                            placement="top"
                          >
                            <span>{{ item.name }}</span>
                          </el-tooltip>

                          <div class="ac_c_i_t_popover" v-if="showMenu(item)">
                            <div
                              class="ac_c_i_t_p_box"
                              v-if="editAppCard === item.id"
                              v-click-outside="handleBlur"
                            >
                              <div
                                @click.stop="copyApp(item)"
                                v-if="item.json && item.json.copy === '1'"
                              >
                                <img
                                  src="../../assets/img/appCenter/appManagement/copy.svg"
                                  alt=""
                                />
                                <span>{{ lang.fz }}</span>
                              </div>
                              <div
                                @click.stop="updateApp(item)"
                                v-if="item.userid === user.userId"
                              >
                                <img
                                  src="../../assets/img/appCenter/appManagement/edit.svg"
                                  alt=""
                                />
                                <span>{{ lang.modifying_agents }}</span>
                              </div>
                              <div
                                @click.stop="delApp(item)"
                                v-if="item.userid === user.userId"
                              >
                                <img
                                  src="../../assets/img/appCenter/appManagement/del.svg"
                                  alt=""
                                />
                                <span>{{ lang.unpublish }}</span>
                              </div>
                            </div>
                            <svg
                              t="1732786015570"
                              @click.stop="updateCard(item.id)"
                              :style="`transform: rotate(${
                                editAppCard === item.id ? '90deg' : '0deg'
                              });background-color:${
                                editAppCard === item.id ? '#F3F7FD' : '#fff'
                              }`"
                              class="icon"
                              viewBox="0 0 1024 1024"
                              version="1.1"
                              xmlns="http://www.w3.org/2000/svg"
                              p-id="9199"
                              width="200"
                              height="200"
                            >
                              <path
                                d="M192 443.733333c-38.4 0-68.266667 29.866667-68.266667 68.266667 0 38.4 29.866667 68.266667 68.266667 68.266667s68.266667-29.866667 68.266667-68.266667c0-38.4-29.866667-68.266667-68.266667-68.266667zM512 443.733333c-38.4 0-68.266667 29.866667-68.266667 68.266667 0 38.4 29.866667 68.266667 68.266667 68.266667s68.266667-29.866667 68.266667-68.266667c0-38.4-29.866667-68.266667-68.266667-68.266667zM832 443.733333c-38.4 0-68.266667 29.866667-68.266667 68.266667 0 38.4 29.866667 68.266667 68.266667 68.266667s68.266667-29.866667 68.266667-68.266667c0-38.4-34.133333-68.266667-68.266667-68.266667z"
                                fill="#111111"
                                p-id="9200"
                              ></path>
                            </svg>
                          </div>
                        </div>
                        <div class="ac_c_i_t2_r_center">
                          <span>{{ item.username }}</span>
                          <span>@{{ item.orgName }}</span>
                        </div>
                        <div class="ac_c_i_t2_r_bottom">
                          <span
                            v-if="['agent', 'workflow'].includes(item.label)"
                            >{{
                              labelSelect.find((i) => i.value === item.label)
                                .label
                            }}</span
                          >
                          <span
                            v-if="
                              ['agent'].includes(item.label) ||
                              (['workflow'].includes(item.label) &&
                                item.json.modes)
                            "
                          >
                            <template v-if="item.label === 'agent'">{{
                              lang.chatMode
                            }}</template>
                            <template v-else-if="item.json.modes">{{
                              wayList[item.json.modes[0]]
                            }}</template>
                          </span>
                          <span v-if="item.tag">
                            <img
                              v-if="item.tag == '1'"
                              src="@/assets/img/appCenter/appManagement/authority_icon.svg"
                              alt=""
                            />
                            <img
                              v-if="item.tag == '2'"
                              src="@/assets/img/appCenter/appManagement/winnow_icon.svg"
                              alt=""
                            />
                            <img
                              v-if="item.tag == '3'"
                              src="@/assets/img/appCenter/appManagement/exclusive_icon.svg"
                              alt=""
                            />

                            <template v-if="item.tag == '1'">{{
                              lang.authority
                            }}</template>
                            <template v-if="item.tag == '2'">{{
                              lang.winnow
                            }}</template>
                            <template v-if="item.tag == '3'">{{
                              lang.exclusive
                            }}</template>
                            <template v-if="item.tag == '4'">{{
                              lang.organization
                            }}</template>
                            <template v-if="item.tag == '5'">{{
                              lang.personal
                            }}</template>
                          </span>
                          <span v-if="item.json.cyid">
                            <el-tooltip class="item" effect="dark" :content="cyname(item.json.cyid)" placement="top">
                                <p>{{ lang.community }}</p>
                            </el-tooltip>
                          </span>
                        </div>
                      </div>
                    </div>
                    <div class="ac_c_i_center2">
                      <div>
                        {{ item.detail }}
                      </div>
                    </div>
                    <div class="ac_c_i_bottom2" @click.stop="">
                      <el-tooltip
                        class="item"
                        effect="light"
                        :content="lang.number_of_users"
                        placement="top"
                      >
                        <div @click.stop="">
                          <img
                            src="../../assets/img/appCenter/appManagement/user_copy.svg"
                          />
                          <span>{{ item.useCount }}</span>
                        </div>
                      </el-tooltip>
                      <span></span>
                      <el-tooltip
                        class="item"
                        effect="light"
                        :content="item.likeId ? lang.unlike : lang.isLike"
                        placement="top"
                      >
                        <div @click.stop="praiseFn(item, !item.likeId ? 0 : 1)">
                          <img
                            :src="
                              require('@/assets/img/appCenter/appManagement/like_icon.svg')
                            "
                            v-if="!item.likeId"
                            style="cursor: pointer"
                          />
                          <img
                            :src="
                              require('@/assets/img/appCenter/appManagement/isLike_icon.svg')
                            "
                            v-else
                            style="cursor: pointer"
                          />
                          <span>{{ item.likeCount }}</span>
                        </div>
                      </el-tooltip>
                      <span></span>
                      <el-tooltip
                        class="item"
                        effect="light"
                        :content="
                          item.collectId ? lang.cancel_collect : lang.collect
                        "
                        placement="top"
                      >
                        <div
                          @click.stop="collectFn(item, !item.collectId ? 0 : 1)"
                        >
                          <img
                            src="../../assets/img/appCenter/appManagement/collect_default.svg"
                            v-if="!item.collectId"
                            style="cursor: pointer"
                          />
                          <img
                            src="../../assets/img/appCenter/appManagement/collect_active.svg"
                            v-else
                            style="cursor: pointer"
                          />
                          <span>{{ item.collectCount }}</span>
                        </div>
                      </el-tooltip>
                    </div>
                  </div>
                </template>
              </div>
            </div>
          </template>
        </div>
        <div class="ac_c_empty" v-if="dataList.length === 0">
          <div>
            <img
              src="@/assets/img/appCenter/appManagement/empty_appImg.svg"
              alt=""
            />
          </div>
          <!-- <span>{{ lang.noData }}...</span> -->
        </div>
      </div>
    </div>
    <addAppDialog
      :userId="user.userId"
      :org="org"
      :oid="oid"
      :region="region"
      ref="addAppDialogRef"
      :typeList="typeList"
      :juriListData="juriListData"
      @success="addAppSuccess"
    />
    <selectAppDialog
      ref="selectAppDialogRef"
      :userId="user.userId"
      :org="org"
      :oid="oid"
      :region="region"
      :juriListData="juriListData"
      @success="selectAppSuccess"
    />
    <releaseAppDialog
      :userId="user.userId"
      :org="org"
      :oid="oid"
      :region="region"
      ref="releaseAppDialogRef"
      :juriListData="juriListData"
      :typeList="typeList"
      @success="releaseAppSuccess"
    />
  </div>
</template>

<script>
const clickOutside = {
  bind(el, binding) {
    // 在元素上绑定一个点击事件监听器
    el.clickOutsideEvent = function (event) {
      // 检查点击事件是否发生在元素的内部
      if (!(el === event.target || el.contains(event.target))) {
        // 如果点击事件发生在元素的外部，则触发指令绑定的方法,将点击的event数据传过去
        binding.value(event);
      }
    };
    // 在文档上添加点击事件监听器
    document.addEventListener("click", el.clickOutsideEvent);
  },
  unbind(el) {
    // 在元素上解除点击事件监听器
    document.removeEventListener("click", el.clickOutsideEvent);
  },
};
import addAppDialog from "./dialog/addAppDialog.vue";
import saveCard from "./components/saveCard.vue";
import selectAppDialog from "./dialog/selectAppDialog.vue";
import releaseAppDialog from "./dialog/releaseAppDialog.vue";
import { myMixin } from "@/common/mixin.js";
// import collectCard from "./dialog/collectCard.vue";
// import recentUseCard from "./dialog/recentUseCard.vue";
export default {
  mixins: [myMixin],
  props: {
    userId: String,
    org: String,
    oid: String,
    region: {
      type: String,
      default: "cn",
    },
    active_type_tab: {
      type: Number,
      default: 0,
    },
  },
  components: {
    addAppDialog,
    saveCard,
    selectAppDialog,
    releaseAppDialog,
    // collectCard,
    // recentUseCard
  },
  directives: {
    "click-outside": clickOutside, // 注册自定义指令
  },
  data() {
    return {
      // 社区数据 
      communityList:[],
      showType: "",
      searchText: "",
      selectJuri: 5,
      selectLabel: "",
      selectModel: "",
      selectTag: "",
      selectSort: "",
      typeList: [],
      selectList: [
        { index: 5, label:this.lang.allApplications2},
        { index: 4, label: this.lang.allApplications },
        //{ index: 2, label: this.lang.withinTheOrganization },
        { index: 1, label: this.lang.myApplication },
        //{ index: 3, label: this.lang.allOrganizations },
        //{ index: 2, label: this.lang.withinTheOrganization },
        //{ index: 1, label: this.lang.mine },
        // { index: 98,label:"已发布"},
        // { index: 99,label:"未发布"},
      ],
      statusList: [
        { value: "", label: this.lang.allStates },
        { value: 1, label: this.lang.test },
        { value: 2, label: this.lang.stabilize },
      ],
      modelList: [
        { value: "", label: this.lang.allMode },
        { value: "0", label: this.lang.chatMode },
        { value: "1", label: this.lang.File_generation },
        { value: "2", label: this.lang.immersion },
      ],
      statusType: "",
      labelSelect: [
        { value: "", label: this.lang.allTypes },
        { value: "agent", label: this.lang.intelligent_agents },
        { value: "workflow", label: this.lang.workflow },
      ],
      tagList: [
        { value: "", label: this.lang.allTag, show: [1, 4] },
        { value: "1", label: this.lang.authority, show: [1, 4] },
        { value: "2", label: this.lang.winnow, show: [1, 4] },
        { value: "3", label: this.lang.exclusive, show: [1, 4] },
        { value: "4", label: this.lang.organization, show: [1, 4] },
        { value: "5", label: this.lang.personal, show: [1] },
      ],
      sortList: [
        { value: "", label: this.lang.default_sort },
        { value: "1", label: this.lang.the_earliest_release },
        { value: "2", label: this.lang.use_the_most },
        { value: "3", label: this.lang.most_likes },
        { value: "4", label: this.lang.most_collected },
      ],
      wayList: [
        this.lang.chatM,
        this.lang.File_generationM,
        this.lang.immersionM,
      ],
      getDataLoading: false,
      dataList: [],
      copyDataList: [],
      recentUse: [],
      collect: [],
      editAppCard: null,
      bannerObj: null,
      userName: null,
      controlsObj: null,
      juriListData: [],
      maxShow: 8,
      selectParams: null,
      routePath: this.$route.path,
      noShowTagOrg: [
        "eed08ac6-7269-11f0-9c7b-005056924926",
        "97271986-97a1-11f0-a823-005056924926",
      ],
			noShowTagOid:[
				'ea4c3273-97a2-11f0-a823-005056924926'
			],
      userDetail: {},
      // region:this.$route.query["region"]
    };
  },
  computed: {
    showMenu() {
      return (data) => {
        let _result = false;
        if (data && this.user.userId) {
          if (
            data.userid === this.user.userId ||
            (data.json && data.json.copy === "1")
          ) {
            _result = true;
          }
        }
        return _result;
      };
    },
    cyname() {
      return (id) => {
        if (!id) return ''
        let kk = this.communityList.filter(e=> e.id == id)
        return kk.length ? kk[0].name : "";
      };
    },
    showCardNum() {
      return (len) => {
        let _result = this.maxShow;
        if (len >= (this.maxShow / 2) * 3) {
          _result = (this.maxShow / 2) * 3;
        }
        return _result;
      };
    },
    // 深圳电教馆-坪山区
    isSzdjkPingShanArea() {
      let _result = false;

      if (this.userDetail && this.userDetail.schooldest) {
        if (
          this.userDetail.schooldest.includes("坪山区") ||
          this.userDetail.schooldest.includes("440310")
        ) {
          _result = true;
        }
      }

      return _result;
    },
  },
  watch: {
    searchText: {
      immediate: false,
      handler() {
        if (this.searchText === "") {
          this.getData();
        }
      },
    },
    region: {
      immediate: false,
      handler() {
        this.getTypeList();
        this.getData();
      },
    },
    userId(newValue) {
      if (newValue) {
        this.getAppStoreControl().then(() => {
          this.getTypeList();
          this.getData();
        });
        this.getCollect();
        this.getRecentUse();
        this.getAppStoreJuri();
        this.getWindowWidthAndSetMaxShow();
      }
    },
    active_type_tab(newValue) {
      if (newValue === 0) {
        this.getAppStoreControl().then(() => {
          this.getTypeList();
          this.getData();
        });
        this.getCollect();
        this.getRecentUse();
        this.getAppStoreJuri();
        // 获取社区列表
        this.getcommunity();
        this.getWindowWidthAndSetMaxShow();
      }
    },
  },
  methods: {
    // 获取社区信息
    getcommunity(){
      let params = {
        org: this.user.org, //用户ID
        oid: this.user.organizeid, //用户ID
      };
       console.log('params',params);
      this.ajax
        .get(this.$store.state.api + "getCococy", params)
        .then((res) => {
          console.log(res);
          this.communityList = res.data[0]
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // 跳转社区
    clickCyBanner(val){
      if ((val.teacher && val.teacher.length && val.teacher.split(',').includes(this.user.userId)) ||
        (val.createuserid == this.user.userId)) {
          this.$router.push({
            path:'/appCommunity',
            query:{
              data:JSON.stringify(val)
            }
          })
       }
    },
    changeType(newIndex) {
      let flag = this.showType === newIndex;
      this.showType = newIndex;
      if (!flag) {
        this.getData();
      }
    },
    changeSelectType() {
      this.getData();
    },
    changeSelectTag() {
      // let _copyData = JSON.parse(JSON.stringify(this.copyDataList));
      // _copyData.sort((a, b) => {
      //   let includesArr = ["f8641a5f-3d29-11f0-b60f-005056924926"];
      //   if (includesArr.includes(a.id)) return -1;
      //   if (includesArr.includes(b.id)) return 1;
      //   return 0;
      // });

      // _copyData = _copyData.filter(
      //   (i) =>
      //     (this.selectTag == "" || i.tag == this.selectTag) &&
      //     !(
      //       (this.noShowTagOrg.includes(this.user.org) || this.noShowTagOid.includes(this.user.organizeid)) &&
      //       ["1", "2"].includes(i.tag)
      //     )
      // );

			// this.dataList = _copyData;
    },
    changeSelectSort() {
      return new Promise((resolve) => {
        let _copyData = JSON.parse(JSON.stringify(this.copyDataList));
        if (this.selectSort == "1") {
          _copyData.sort(
            (a, b) => new Date(a.create_at) - new Date(b.create_at)
          );
        } else if (this.selectSort == "2") {
          _copyData.sort((a, b) => b.useCount - a.useCount);
        } else if (this.selectSort == "3") {
          _copyData.sort((a, b) => b.likeCount - a.likeCount);
        } else if (this.selectSort == "4") {
          _copyData.sort((a, b) => b.collectCount - a.collectCount);
        } else if (this.selectSort === "") {
          //默认
          _copyData.sort((a, b) => b.useCount - a.useCount);
          //专属放前面
          _copyData.sort((a, b) => {
            if (a.tag === "3" && b.tag !== "3") {
              return -1; // a 在前
            } else if (a.tag !== "3" && b.tag === "3") {
              return 1; // b 在前
            }
            return 0; // 保持原顺序
          });
        }

        _copyData.sort((a, b) => {
          let includesArr = ["f8641a5f-3d29-11f0-b60f-005056924926"];
          if (includesArr.includes(a.id)) return -1;
          if (includesArr.includes(b.id)) return 1;
          return 0;
        });

        //根据人数排序
        console.log("_copyData", _copyData);

        if (JSON.stringify(this.dataList) != JSON.stringify(_copyData)) {
          this.dataList = _copyData;
          this.$forceUpdate();
        }
        resolve();
      });
    },
    getData() {
      const _region = this.region;
      this.getDataLoading = true;
			console.log(this.user)
      let params = {
        uid: this.user.userId, //用户ID
        name: this.searchText, //应用名称搜索
        label: this.selectLabel, //应用的标签搜索
        type: this.showType, //应用的类型
        juri: this.selectJuri, //应用权限 1:我的  2：组织内  3：所有人
        stand: this.region ? this.region : "cn", //cn站还是hk站
        status: this.statusType,
        model: this.selectModel,
        exportType:
          this.controlsObj &&
          this.controlsObj.exportTypeList &&
          this.controlsObj.exportTypeList.length > 0
            ? this.controlsObj.exportTypeList.join(",")
            : "",
      };
      const _params = JSON.stringify(params);
      this.selectParams = _params;
      this.ajax
        .get(this.$store.state.api + "select_appStore_exportType2", params)
        .then((res) => {
          if (this.region != _region) return;
          //防止请求过快并请求延迟
          if (this.selectParams != _params) return;
          this.getDataLoading = false;
          let _data = res.data[0];
          if (_data.length > 0) {
            _data.forEach((i) => {
              if (i.json) {
                i.json = JSON.parse(i.json);
              }
            });
            if (this.juriListData.length > 0) {
              _data = this.setDataTag(_data);
            }
            this.dataList = _data;
            this.copyDataList = _data;
            this.changeSelectSort().then(() => {
              this.changeSelectTag();
            });
          } else {
            this.dataList = [];
            this.copyDataList = [];
          }
        })
        .catch(() => {
          this.getDataLoading = false;
          this.$message.error(this.lang.Failed_to_obtain_application);
        });
    },
    setDataTag(_list) {
      let _result = _list;
      _result.forEach((item) => {
        if (
          this.juriListData.find(
            (i) => i.jid === item[i.type] && i.utype === "1"
          ) &&
          item.juri == "3"
        ) {
          item.tag = "1"; //官方
        } else if (
          this.juriListData.find(
            (i) => i.jid === item[i.type] && i.utype === "2"
          ) &&
          item.juri == "3"
        ) {
          item.tag = "2"; //精选
        } else if (item.role === 1 && item.juri == "2") {
          item.tag = "3"; //专属
        } else if (item.juri === "2") {
          item.tag = "4"; //组织
        } else if (item.userid === this.user.userId && item.juri === "1") {
          item.tag = "5"; //个人
        }
      });
      this.setTagList(_result);
      return _result;
      // this.dataList = _result;
      // this.copyDataList = _result;
    },
    setTagList(_list) {
      let _result = [{ value: "", label: this.lang.allTag }];
      let _tagList = [];
      _list
        .map((i) => i.tag)
        .forEach((i) => {
          if (i && !_tagList.includes(i)) {
            _tagList.push(i);
          }
        });
      _tagList.sort((a, b) => a - b);

      _tagList.forEach((i) => {
        switch (i) {
          case "1":
            _result.push({ value: "1", label: this.lang.authority });
            break;
          case "2":
            _result.push({ value: "2", label: this.lang.winnow });
            break;
          case "3":
            _result.push({ value: "3", label: this.lang.exclusive });
            break;
          case "4":
            _result.push({ value: "4", label: this.lang.organization });
            break;
          case "5":
            _result.push({ value: "5", label: this.lang.personal });
            break;
        }
      });

      // if (this.selectTag != "" && !_tagList.includes(this.selectTag)) {
      //   this.selectTag = "";
      // }
      this.tagList = _result;
    },
    addApp() {
      this.$refs.addAppDialogRef.open({ type: 1 });
    },
    selectApp() {
      this.$refs.selectAppDialogRef.open();
    },
    selectAppSuccess(data) {
      if (data) {
        this.$refs.selectAppDialogRef.close();
        this.$refs.releaseAppDialogRef.open({
          form: {
            id: data.id,
            name: data.name,
            label: data.label,
            detail: data.detail,
            url: data.url,
            type: data.type,
            juri: data.juri,
            stand: data.stand,
            json: data.json,
          },
        });
      }
    },
    updateApp(data) {
      this.$refs.addAppDialogRef.open({
        type: 2,
        form: {
          id: data.id,
          name: data.name,
          label: data.label,
          detail: data.detail,
          url: data.url,
          type: data.type,
          juri: data.juri,
          stand: data.stand,
          json: data.json,
        },
      });
    },
    //复制app
    async copyApp(item) {
      this.$confirm(
        `${this.lang.copyText.replace("《xx》", "《" + item.name + "》")}？`,
        this.lang.fz,
        {
          confirmButtonText: this.lang.queding,
          cancelButtonText: this.lang.cancel,
          type: "warning",
        }
      )
        .then(async () => {
          let _notify = this.$notify({
            title: this.lang.Copying,
            message: this.lang.copyingText.replace(
              "《xx》",
              "《" + item.name + "》"
            ),
            position: "bottom-right",
            duration: 0,
            type: "info",
          });

          let _status = await this.copyAgentOrWorkflow(item);
          this.addOp3(
            1,
            "",
            { id: item.id, name: item.name, type: "appStoreCopy" },
            "success"
          );
          if (_status == 1) {
            this.$message.success(this.lang.copySuccessToWorkflow);
            this.insertSave(item,3)
          } else if (_status == 2) {
            this.$message.success(this.lang.copySuccessToAgent);
            this.insertSave(item,3)
          } else if (_status == 3) {
            this.$message.error(this.lang.copyFail_notData);
          } else if (_status == 0) {
            this.$message.error(this.lang.fzsb);
            this.addOp3(
              1,
              "",
              { id: item.id, name: item.name, type: "appStoreCopy" },
              "success"
            );
          }
          _notify.close();
        })
        .catch(() => {});
    },
    async copyAgentOrWorkflow(item) {
      return new Promise((resolve) => {
        let url = item.url;
        let id =
          this.queryURLParams(url, "id") ||
          item.url.split("/")[item.url.split("/").length - 1];
        if (!id) {
          return resolve(3);
          // return this.$message.error("复制失败，未找到对应id")
        }
        if (item.label == "workflow") {
          //复制工作流
          this.ajax
            .get(`https://appapi.cocorobo.cn/api/agents/muti_agent/${id}`)
            .then(async (res) => {
              let _data = res.data;

              let _modes = "wu";

              if (item.json.modes) {
                _modes = item.json.modes[0];
              }
              let _idList = [];
              if (
                _data["dialoguePublishDataId"] &&
                (_modes == "wu" || _modes == "0")
              )
                _idList.push(_data["dialoguePublishDataId"]);
              if (
                _data["immersivePublishDataId"] &&
                (_modes == "wu" || _modes == "2")
              )
                _idList.push(_data["immersivePublishDataId"]);
              if (
                _data["cardPublishDataId"] &&
                (_modes == "wu" || _modes == "1")
              )
                _idList.push(_data["cardPublishDataId"]);
              if (_idList.length <= 0) {
                resolve(3);
                return;
              }
              // /api/agents/copy_mutiAgent
              this.ajax
                .post("https://appapi.cocorobo.cn/api/agents/copy_mutiAgent", {
                  ids: _idList,
                  userId: this.user.userId,
                  username: this.userName
                    ? this.userName
                    : await this.getUserName(this.user.userId),
                })
                .then(() => {
                  resolve(1);
                })
                .catch(() => {
                  resolve(0);
                });
            });
        } else if (item.label == "agent") {
          //复制智能体
          this.ajax
            .get(`https://appapi.cocorobo.cn/api/agents/agent/parent/${id}`)
            .then(async (res) => {
              let _id = res.data.id;
              if (_id) {
                let _idList = [_id];
                this.ajax
                  .post("https://appapi.cocorobo.cn/api/agents/copy_agent", {
                    ids: _idList,
                    userId: this.user.userId,
                    username: this.userName
                      ? this.userName
                      : await this.getUserName(this.user.userId),
                  })
                  .then(() => {
                    resolve(2);
                  })
                  .catch(() => {
                    resolve(0);
                  });
              }
            })
            .catch(() => {
              resolve(0);
              // this.$message.error("")
            });
          // let _idList = [id];
          // this.ajax.post('https://appapi.cocorobo.cn/api/agents/copy_agent',{
          //   ids: _idList,
          //   userId: this.userId,
          //   username: this.userName?this.userName:await this.getUserName(this.userId),
          // }).then(_=>{
          //   resolve(2);
          // }).catch(e=>{
          //   console.log(e)
          //   resolve(0)
          // })
        }
      });
    },
    // 删除记录
    cancelAppStoreSave(item) {
      let params = [
        {
          sid: item.sid,
        },
      ];
      this.ajax
        .post(this.$store.state.api + "delete_appStoreSave", params)
        .then((res) => {
          if (res.data) {
            this.$message.success(this.lang.delete_cg);
          }
          this.addOp3(
            1,
            "",
            { id: item.id, name: item.name, type: "appStoreUnHistory" },
            "success"
          );
          this.getRecentUse();
        })
        .catch((e) => {
          this.addOp3(
            1,
            "",
            { id: item.id, name: item.name, type: "appStoreUnHistory" },
            e
          );
          this.$message.error(this.lang.deletion_failure);
          this.getRecentUse();
        });
    },
    updateCard(id) {
      if (this.editAppCard === id) return (this.editAppCard = null);
      this.editAppCard = id;
    },
    handleBlur() {
      this.updateCard(null);
    },
    addAppSuccess(data, type) {
      if (type === 1) {
        //添加
        let params = [
          {
            name: data.name, //app名称
            userid: this.user.userId, //创建的用户ID
            label: data.label, //app标签
            detail: data.detail, //app简介
            url: data.url, //app链接
            type: data.type, //app类型
            juri: data.juri, //app权限 1:我的 2:组织 3:所有人
            stand: this.region ? this.region : "cn", //语言
            json: JSON.stringify(data.json), //其他信息
          },
        ];
        this.ajax
          .post(this.$store.state.api + "insert_appStore", params)
          .then((res) => {
            if (res.data[0][0]["id"]) {
              this.$message.success(this.lang.addSuccessfully);
              this.$refs.addAppDialogRef.close(true);
              this.getData();
            } else {
              this.$message.error(this.lang.addFailure);
              this.$refs.addAppDialogRef.loading = false;
            }
          })
          .catch(() => {
            this.$message.error(this.lang.addFailure);
          });
      } else if (type === 2) {
        let params = [
          {
            aid: data.id,
            name: data.name, //app名称
            userid: this.user.userId, //创建的用户ID
            label: data.label, //app标签
            detail: data.detail, //app简介
            url: data.url, //app链接
            type: data.type, //app类型
            juri: data.juri, //app权限 1:我的 2:组织 3:所有人
            stand: this.region ? this.region : "cn", //语言
            json: JSON.stringify(data.json), //其他信息
          },
        ];
        this.ajax
          .post(this.$store.state.api + "update_appStore", params)
          .then((res) => {
            if (res.data) {
              this.$message.success(this.lang.modifiedSuccessfully);
              this.$refs.addAppDialogRef.close(true);
              this.getData();
            } else {
              this.$message.error(this.lang.modificationFailure);
              this.$refs.addAppDialogRef.loading = false;
            }
          })
          .catch(() => {
            this.$message.error(this.lang.modificationFailure);
          });
        this.updateAppData(data);
      }
    },
    updateAppData(data) {
      if (data.json.icon || data.name) {
        let url = data.url;
        let id =
          this.queryURLParams(url, "id") ||
          data.url.split("/")[data.url.split("/").length - 1];
        if (!id) {
          return;
          // return this.$message.error("复制失败，未找到对应id")
        }
        //同步修改工作流的数据

        let params2 = {
          source: data.label == "agent" ? "agent" : "mutiagent",
          name: data.name,
          headUrl: data.json.icon,
          mode:
            data.label == "agent"
              ? "0"
              : data.json.modes.length > 0
              ? data.json.modes[0]
              : "0",
        };
        this.ajax
          .post(
            "https://appapi.cocorobo.cn/api/agents/modify_publish_app/" + id,
            params2
          )
          .then(() => {})
          .catch(() => {});
      }
    },
    releaseAppSuccess(data) {
      this.$refs.releaseAppDialogRef.loading = true;
      let params = [
        {
          aid: data.id,
          name: data.name, //app名称
          userid: this.user.userId, //创建的用户ID
          label: data.label, //app标签
          detail: data.detail, //app简介
          url: data.url, //app链接
          type: data.type, //app类型
          juri: data.juri, //app权限 1:我的 2:组织 3:所有人
          stand: this.region ? this.region : "cn", //语言
          json: JSON.stringify(data.json), //其他信息
        },
      ];
      this.addOp3(
        1,
        "",
        { id: data.id, name: data.name, type: "appStoreUpdate" },
        "success"
      );
      this.ajax
        .post(this.$store.state.api + "update_appStore", params)
        .then((res) => {
          if (res.data) {
            this.$message.success(this.lang.releaseSuccess);
            this.$refs.releaseAppDialogRef.close(true);
          } else {
            this.$message.error(this.lang.publishingFailure);
            this.$refs.releaseAppDialogRef.loading = false;
          }
          this.getData();
        })
        .catch(() => {
          this.$message.error(this.lang.publishingFailure);
        });
    },
    getTypeList() {
      const _region = this.region;
      let params = {
        suserid: this.user.userId, //用户ID
        sorg: this.user.org,
        soid: this.user.organizeid,
        sstand: this.region ? this.region : "cn",
        exportType:
          this.controlsObj &&
          this.controlsObj.exportTypeList &&
          this.controlsObj.exportTypeList.length > 0
            ? this.controlsObj.exportTypeList.join(",")
            : "",
      };

      this.ajax
        .get(this.$store.state.api + "select_appStoreType_exceptType", params)
        .then((res) => {
          if (this.region !== _region) return;
          let data = res.data[0];
          if (data.length > 0) {
            // data.forEach(i => {
            //   if (i.open == undefined) {
            //     i.open = true;
            //   }
            // });
            
            this.typeList = data;
            if(!data.map(i=>i.id).includes(this.showType)){
              this.changeType('')
            }
          }
        })
        .catch(() => {
          this.$message.error(
            this.lang.failed_to_obtain_the_application_type_Procedure
          );
        });
    },
    async openApp(item) {
      let _url = item.url;

      let includesArr = ["f8641a5f-3d29-11f0-b60f-005056924926"];
      if (includesArr.includes(item.id)) {
        _url = this.addParamsToUrl(_url, {
          userid: this.user.userId,
          oid: this.user.organizeid,
          org: this.user.org,
        });

        if (window.location.href.indexOf("beta") == -1) {
          _url = _url.replace("beta.cloud.cocorobo.cn", "cloud.cocorobo.cn");
        }
        console.log("_url", _url);
        // _url = 'https://app.cocorobo.cn/app/f8641a5f-3d29-11f0-b60f-005056924926';
      }
      //const newWindow = window.open(item.url, "_blank");
      //const openTime = new Date();
      //newWindow.onbeforeunload = () => {
      //	const closeTime = new Date();
      //	console.log(`${this.lang.windowClosed}，打开时间：${openTime.toLocaleString()}，关闭时间：${closeTime.toLocaleString()}`)
      //	// this.$message.info(`${this.lang.windowClosed}，打开时间：${openTime.toLocaleString()}，关闭时间：${closeTime.toLocaleString()}`);
      //};

      let newWindow = window.open(_url, "_blank");
      //   let newWindow = window.open("http://localhost:8080/#/dialogMode?id=b64e944f-9646-4f52-890a-79d865988d06&type=agent", "_blank");

      let _this = this;
      let _id = item.id;
      let _time = new Date()
        .toLocaleString("zh-CN", { hour12: false, timeZone: "Asia/Shanghai" })
        .replace(/\//g, "-");
      //   let index = 1
      newWindow.onload = () => {
        console.log("窗口打开");
        newWindow.onunload = () => {
          console.log("窗口即将关闭");
          // if(index == 2){
          _this.addOp3(
            _time,
            "",
            { id: _id, name: item.name, type: "appStoreClose" },
            "success",
            1
          );
          // }else {
          // console.log('index+1');
          // index++
          // }
        };
      };

      this.addOp3(
        1,
        "",
        { id: item.id, name: item.name, type: "appStoreOpen" },
        "success"
      );
      this.insertSave(item, 1);
      this.dataList.find((i) => i.id == item.id).useCount += 1;
      await this.insertSave(item, 4).then(() => {
        this.getRecentUse();
      });
    },
    //给地址添加参数
    addParamsToUrl(url, obj) {
      if (!url) {
        return url;
      }

      if (!obj || Object.keys(obj).length === 0) {
        return url;
      }

      // 处理以@开头的URL，去除@符号
      let processedUrl = url;

      let result = "";

      // 检查是否包含#
      const hashIndex = processedUrl.indexOf("#");
      if (hashIndex !== -1) {
        const baseUrl = processedUrl.substring(0, hashIndex);
        let hashPart = processedUrl.substring(hashIndex);

        // 检查hash部分是否已经包含参数
        const hashParamIndex = hashPart.indexOf("?");
        if (hashParamIndex !== -1) {
          // 已经有参数，添加&
          const hashBase = hashPart.substring(0, hashParamIndex + 1);
          const hashParams = hashPart.substring(hashParamIndex + 1);
          let paramString = "";

          Object.keys(obj).forEach((key, index) => {
            if (obj[key] !== undefined && obj[key] !== null) {
              paramString +=
                (index === 0 && hashParams === "" ? "" : "&") +
                `${encodeURIComponent(key)}=${encodeURIComponent(obj[key])}`;
            }
          });

          result =
            baseUrl +
            hashBase +
            hashParams +
            (hashParams ? "&" : "") +
            paramString;
        } else {
          // 没有参数，添加?
          let paramString = "";

          Object.keys(obj).forEach((key, index) => {
            if (obj[key] !== undefined && obj[key] !== null) {
              paramString +=
                (index === 0 ? "?" : "&") +
                `${encodeURIComponent(key)}=${encodeURIComponent(obj[key])}`;
            }
          });

          result = baseUrl + hashPart + paramString;
        }
      } else {
        // 没有hash部分，正常添加参数
        try {
          const urlObj = new URL(processedUrl);

          // 遍历对象，添加或更新参数
          Object.keys(obj).forEach((key) => {
            if (obj[key] !== undefined && obj[key] !== null) {
              urlObj.searchParams.set(key, obj[key]);
            }
          });

          result = urlObj.href;
        } catch (e) {
          // 如果URL无效（可能是相对路径），使用字符串处理
          const separator = processedUrl.includes("?") ? "&" : "?";
          let paramString = "";

          Object.keys(obj).forEach((key, index) => {
            if (obj[key] !== undefined && obj[key] !== null) {
              paramString +=
                (index === 0 ? "" : "&") +
                `${encodeURIComponent(key)}=${encodeURIComponent(obj[key])}`;
            }
          });

          result = paramString
            ? `${processedUrl}${separator}${paramString}`
            : processedUrl;
        }
      }

      return result;
    },

    resetData() {
      this.searchText = "";
      this.selectJuri = 3;
      this.showType = "";
      this.getData();
    },
    getRecentUse() {
      let params = {
        uid: this.user.userId,
        type: 4,
        limit: 10,
      };

      this.ajax
        .get(this.$store.state.api + "select_appStoreSave", params)
        .then((res) => {
          let data = res.data[0];
          if (data.length > 0) {
            data.forEach((i) => {
              if (i.json) {
                i.json = JSON.parse(i.json);
              }
            });
            this.recentUse = data;
          } else {
            this.recentUse = [];
          }
        })
        .catch(() => {
          // this.$message.error("获取收藏应用失败")
        });
    },
    getCollect() {
      let params = {
        uid: this.user.userId,
        type: 0,
        limit: 0,
      };
      this.ajax
        .get(this.$store.state.api + "select_appStoreSave", params)
        .then((res) => {
          let data = res.data[0];
          if (data.length > 0) {
            data.forEach((i) => {
              if (i.json) {
                i.json = JSON.parse(i.json);
              }
            });
            this.collect = data;
          } else {
            this.collect = [];
          }
        })
        .catch(() => {
          this.$message.error(
            this.lang.failed_to_obtain_the_favorite_application_Procedure
          );
        });
    },
    insertSave(item, type) {
      return new Promise((resolve) => {
        let params = [
          {
            uid: this.user.userId,
            type: type,
            aid: item.id,
            json: "",
          },
        ];

        this.ajax
          .post(this.$store.state.api + "insert_appStoreSave", params)
          .then((res) => {
            if (res.data) {
              resolve(1);
            }
          })
          .catch(() => {
            resolve(0);
          });
      });
    },
    delApp(item) {
      this.$confirm(
        this.lang.publishingStopText.replace("《xx》", "《" + item.name + "》"),
        this.lang.confirm_to_cancel_publishing_the_application,
        {
          confirmButtonText: this.queding,
          cancelButtonText: this.cancel,
          type: "warning",
        }
      )
        .then(async () => {
          let status = await this.delAgentOrWorkflow(item);

          if (status == 0) {
            this.$message.success(this.lang.cancel_publication_successfully);
            this.getData();
          } else if (status == 1) {
            this.$message.error(this.lang.unpublishFailure);
            this.getData();
          } else if (status == 2) {
            let params = [
              {
                uid: this.user.userId,
                aid: item.id,
              },
            ];
            this.ajax
              .post(this.$store.state.api + "delete_appStore", params)
              .then((res) => {
                if (res.data) {
                  this.$message.success(
                    this.lang.cancel_publication_successfully
                  );
                  this.getData();
                } else {
                  this.$message.error(this.lang.unpublishFailure);
                }
                if (this.collect.findIndex((i) => i.id == item.id) != -1) {
                  this.getCollect();
                }
              })
              .catch(() => {
                this.$message.error(this.lang.unpublishFailure);
              });
          }
        })
        .catch(() => {});
    },
    async delAgentOrWorkflow(item) {
      return new Promise((resolve) => {
        let url = item.url;
        let id =
          this.queryURLParams(url, "id") ||
          item.url.split("/")[item.url.split("/").length - 1];
        if (!id) {
          return resolve(3);
          // return this.$message.error("复制失败，未找到对应id")
        }
        if (item.label == "workflow") {
          //复制工作流
          if (item.json.modes) {
            let params = {
              status: 0,
              modes: item.json.modes,
            };
            this.ajax
              .post(
                `https://appapi.cocorobo.cn/api/agents/cancelPublishMutiAgent/${id}`,
                params
              )
              .then((res) => {
                let _msg = res.data.message;
                if (_msg == "MutiAgent unpublished successfully") {
                  resolve(0);
                } else {
                  resolve(1);
                }
              })
              .catch(() => {
                resolve(1);
              });
          } else {
            resolve(2);
          }
        } else if (item.label == "agent") {
          //复制智能体
          let params = {
            status: 0,
            modes: ["0"],
          };
          this.ajax
            .post(
              `https://appapi.cocorobo.cn/api/agents/cancelPublishAgent/${id}`,
              params
            )
            .then((res) => {
              let _msg = res.data.message;
              if (_msg == "Agent unpublished successfully") {
                resolve(0);
              } else {
                resolve(1);
              }
            })
            .catch(() => {
              resolve(1);
            });
        }
      });
    },
    changeShowPage(newPage) {
      this.$emit("changeShowCard", newPage);
    },
    getBanner() {
      let params = {
        uid: this.user.userId,
        oid: this.user.oid,
        org: this.user.org,
        type: 4,
      };

      this.ajax
        .get(this.$store.state.api + "select_bannerByoidORorg", params)
        .then((res) => {
          let _data = res.data[0];
          if (_data[0]) {
            this.bannerObj = _data[0];
          } else {
            this.bannerObj = null;
          }
        })
        .catch(() => {});
    },
    praiseFn(item, type = 0) {
      //点赞
      if (type === 0) {
        //点赞
        let params = [
          {
            uid: this.user.userId,
            type: 2,
            aid: item.id,
            json: "",
          },
        ];
        this.ajax
          .post(this.$store.state.api + "insert_appStoreSave", params)
          .then((res) => {
            if (res.data) {
              let _likeId = res.data[0][0].id;
              this.dataList.find((i) => i.id === item.id).likeCount += 1;
              this.dataList.find((i) => i.id === item.id).likeId = _likeId;
              this.$message.success(this.lang.clickSuccessful);
              this.addOp3(
                1,
                "",
                { id: item.id, name: item.name, type: "appStoreLike" },
                "success"
              );
            }
          })
          .catch((e) => {
            this.$message.error(this.lang.failToLike);
            this.addOp3(
              1,
              "",
              { id: item.id, name: item.name, type: "appStoreLike" },
              e
            );
          });
      } else if (type === 1) {
        //取消点赞
        let params = [
          {
            sid: item.likeId,
          },
        ];
        this.ajax
          .post(this.$store.state.api + "delete_appStoreSave", params)
          .then((res) => {
            if (res.data) {
              this.dataList.find((i) => i.id === item.id).likeCount -= 1;
              this.dataList.find((i) => i.id === item.id).likeId = "";
              this.$message.success(this.lang.unlikeSuccessful);
              this.addOp3(
                1,
                "",
                { id: item.id, name: item.name, type: "appStoreUnLike" },
                "success"
              );
            }
          })
          .catch((e) => {
            this.addOp3(
              1,
              "",
              { id: item.id, name: item.name, type: "appStoreUnLike" },
              e
            );
            this.$message.error(this.lang.failedToUnlike);
          });
      }
    },
    collectFn(item, type = 0) {
      //收藏
      if (type === 0) {
        //收藏
        let params = [
          {
            uid: this.user.userId,
            type: 0,
            aid: item.id,
            json: "",
          },
        ];
        this.ajax
          .post(this.$store.state.api + "insert_appStoreSave", params)
          .then((res) => {
            if (res.data) {
              let _colletId = res.data[0][0].id;
              this.dataList.find((i) => i.id === item.id).collectCount += 1;
              this.dataList.find((i) => i.id === item.id).collectId = _colletId;
              this.$message.success(this.lang.successfulCollection);
              this.addOp3(
                1,
                "",
                { id: item.id, name: item.name, type: "appStoreCollect" },
                "success"
              );
            }
            this.getCollect();
          })
          .catch((e) => {
            this.addOp3(
              1,
              "",
              { id: item.id, name: item.name, type: "appStoreCollect" },
              e
            );
            this.getCollect();
            this.$message.error(this.lang.collectionFailure);
          });
      } else if (type === 1) {
        //取消收藏
        let params = [
          {
            sid: item.collectId,
          },
        ];
        this.ajax
          .post(this.$store.state.api + "delete_appStoreSave", params)
          .then((res) => {
            if (res.data) {
              if (this.dataList.find((i) => i.id === item.id)) {
                this.dataList.find((i) => i.id === item.id).collectCount -= 1;
                this.dataList.find((i) => i.id === item.id).collectId = "";
              }

              this.$message.success(this.lang.unCollectSuccessfully);
              this.addOp3(
                1,
                "",
                { id: item.id, name: item.name, type: "appStoreUnCollect" },
                "success"
              );
            }
            this.getCollect();
          })
          .catch((e) => {
            this.addOp3(
              1,
              "",
              { id: item.id, name: item.name, type: "appStoreUnCollect" },
              e
            );
            this.$message.error(this.lang.unCollectFailed);
            this.getCollect();
          });
      }
    },
    queryURLParams(url, paramName) {
      // 正则表达式模式，用于匹配URL中的参数部分。正则表达式的含义是匹配不包含 ?、&、= 的字符作为参数名，之后是等号和不包含 & 的字符作为参数值
      let pattern = /([^?&=]+)=([^&]+)/g;
      let params = {};

      // match用于存储正则匹配的结果
      let match;
      // while 循环和正则表达式 exec 方法来迭代匹配URL中的参数
      while ((match = pattern.exec(url)) !== null) {
        // 在字符串url中循环匹配pattern，并对每个匹配项进行解码操作，将解码后的键和值分别存储在key和value变量中
        let key = decodeURIComponent(match[1]);
        let value = decodeURIComponent(match[2]);

        if (params[key]) {
          if (Array.isArray(params[key])) {
            params[key].push(value);
          } else {
            params[key] = [params[key], value];
          }
        } else {
          // 参数名在 params 对象中不存在，将该参数名和对应的值添加到 params 对象中
          params[key] = value;
        }
      }

      if (!paramName) {
        // 没有传入参数名称, 返回含有所有参数的对象params
        return params;
      } else {
        if (params[paramName]) {
          return params[paramName];
        } else {
          return "";
        }
      }
    },
    getUserName(uid) {
      return new Promise((resolve) => {
        let params = { uid: uid };
        this.ajax
          .get(this.$store.state.api + "getUser", params)
          .then((res) => {
            let data = res.data[0][0];
            this.userName = data.username;
            resolve(data.username);
          })
          .catch(() => {});
      });
    },
    async getAppStoreControl() {
      return new Promise((resolve) => {
        let params = {
          uid: this.user.userId,
          org: this.user.org,
          oid: this.user.oid,
        };
        this.getDataLoading = true;
        let controlsObj = {
          logoUrl:
            "https://ccrb.s3.cn-northwest-1.amazonaws.com.cn/default%2FFrame+4273197481741333327961.png",
          bannerUrl:
            "https://ccrb.s3.cn-northwest-1.amazonaws.com.cn/default%2FFrame+30141733970358224.svg",
          exportTypeList: [],
        };
        this.ajax
          .get(this.$store.state.api + "select_appStore_controls", params)
          .then((res) => {
            let _data = res.data[0];
            if (_data[0]) {
              controlsObj = JSON.parse(_data[0].json);
            }
            this.controlsObj = controlsObj;
            this.getDataLoading = false;
            resolve();
          })
          .catch(() => {
            this.controlsObj = controlsObj;
            this.getDataLoading = false;
            resolve();
          });
      });
    },
    //获取显示标权限
    getAppStoreJuri() {
      this.ajax
        .get(this.$store.state.api + "select_appStorJuri")
        .then((res) => {
          let _data = res.data;
          if (_data[0].length) {
            this.juriListData = _data[0];
            if (this.dataList.length > 0 || this.selectTag.length < 1) {
              this.dataList = this.setDataTag(this.dataList);
            }
          }
        })
        .catch(() => {});
    },
    //获取窗口宽度并修改列表显示个数
    getWindowWidthAndSetMaxShow() {
      let _winWidth = window.innerWidth;
      let _showNum = 8;
      if (_winWidth >= 2601) {
        _showNum = 14;
      } else if (_winWidth <= 2600 && _winWidth >= 2256) {
        _showNum = 12;
      } else if (_winWidth <= 2255 && _winWidth >= 1874) {
        _showNum = 10;
      } else if (_winWidth <= 1873 && _winWidth >= 1526) {
        _showNum = 8;
      } else if (_winWidth <= 1525 && _winWidth >= 1201) {
        _showNum = 6;
      } else if (_winWidth <= 1200) {
        _showNum = 4;
      }
      this.maxShow = _showNum;
    },
    addOp(uid) {
      let params = [
        {
          uid: this.user.userId,
          text: uid,
          type: "appStore_open",
          time: "",
        },
      ];

      this.ajax
        .post(this.$store.state.api + "/addOperationTimeT2", params)
        .then(() => {})
        .catch(() => {});
    },
    //点击banner事件
    clickBanner(item) {
      this.$message.info('暂无准入权限，请联系社区发起人。')
      console.log('禁止使用',item);
      // if (item.path) {
      //   this.$router.push(item.path);
      // } else if (item.http) {
      //   window.open(item.http, "_blank");
      // }
    },
    // 获取用户详细数据
    selectUser() {
      this.ajax
        .get(this.$store.state.api + "selectUser", { userid: this.user.userId })
        .then((res) => {
          let _res = res.data[0];
          if (_res.length > 0) {
            this.userDetail = _res[0];
          }
        });
    },
  },
  mounted() {
    // this.getAppStoreControl().then(() => {
    // 	this.getTypeList();
    // 	this.getData();
    // });
    // this.getCollect();
    // this.getRecentUse();
    // this.getAppStoreJuri();
    // this.getWindowWidthAndSetMaxShow();
    // window.addEventListener('resize',this.getWindowWidthAndSetMaxShow)
    // window.onload = () => {
      setTimeout(() => {
        if(this.$store.state.mode == 'pptMode'){
          this.showType = "b64ad457-be72-11ef-a2d1-005056b86dbx"
          // this.showType = "a748cc16-be72-11ef-a2d1-005056b86db5" //测试
        }
        this.selectUser();
        this.getAppStoreControl().then(() => {
          this.getTypeList();
          this.getData();
        });
        this.getCollect();
        this.getRecentUse();
        this.getAppStoreJuri();
        this.getWindowWidthAndSetMaxShow();
        // 获取社区 
        this.getcommunity()
        window.addEventListener("resize", this.getWindowWidthAndSetMaxShow);
      }, 0);
    // };
  },
  // activated(){
  // 	this.getAppStoreControl().then(() => {
  // 				this.getTypeList();
  // 				this.getData();
  // 			});
  // 			this.getCollect();
  // 			this.getRecentUse();
  // 			this.getAppStoreJuri();
  // 			this.getWindowWidthAndSetMaxShow();
  // }
};
</script>

<style scoped lang="scss">
.appManagement {
  width: 100vw;
  height: 100%;
  min-height: calc(100vh - 50px);
  background-color: #f2f4f7;
  margin: 0;
  overflow: auto;
  box-sizing: border-box;
  /* padding: 20px; */
  display: flex;
  justify-content: space-between;
}

.ac_left {
  /* width: 280px;
  min-width: 280px; */
  width: clamp(200px, 12vw, 280px);
  min-width: 200px;
  /* margin-right: 20px; */
  height: 100%;
  /* border-radius: 5px; */
  background-color: #fff;
  /* box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.1); */
  box-sizing: border-box;
  padding: 10px;
  overflow: auto;
  position: relative;
}

.ac_left > .find {
  width: 100%;
  height: 45px;
  background-color: #fff;
  border-radius: 10px;
  border: 1px solid #f3f7fd;
  box-sizing: border-box;
  padding: 0 20px 0 10px;
  display: flex;
  align-items: center;
  /* box-shadow: 2px 2px 4px 0px #1D39830A; */
  box-shadow: 0px 0px 4px 2px #1d39830a;
  margin-bottom: 10px;
  font-weight: bold;
  font-size: 16px;
  color: #000000e5;
}

.ac_left > .find > img {
  width: 22px;
  height: 22px;
  margin-right: 10px;
}

.leftToolBackground {
  width: 100%;
  height: auto;
  position: absolute;
  bottom: 0;
  left: 0;
}

.ac_right {
  flex: 1;
  padding-left: 20px;
  min-width: 800px;
  height: 100%;
  overflow: auto;
  display: flex;
  padding-right: 10px;
  padding-top: 10px;
  box-sizing: border-box;
  flex-direction: column;
  background-image: url("@/assets/img/appCenter/background2.png");
  background-repeat: no-repeat;
  background-size: 100% 100%;
}

.ac_header {
  width: 100%;
  height: auto;
  border-radius: 5px;
  /* box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.1); */
  background-color: none;
}

.ac_h_top {
  width: 100%;
  height: 50px;
  display: flex;
  align-items: center;
  box-sizing: border-box;
  padding: 0 15px;
  border-bottom: 1px solid #eeeeee;

  position: relative;
  justify-content: center;
}

.ac_h_top > span {
  font-size: 22px;
  position: relative;
  margin-right: 25px;
  cursor: pointer;
  display: flex;
  align-items: center;
}

.ac_h_top > span > svg {
  width: 22px;
  height: 22px;
  fill: #1a1a1a;
  margin-right: 10px;
}

.ac_h_t_active {
  color: #0354d7;
}

.ac_h_t_active > svg {
  fill: #0354d7 !important;
}

/* .ac_h_t_active::after {
  content: "";
  position: absolute;
  width: 100%;
  height: 3px;
  border-radius: 4px;
  background-color: #409eff;
  left: 0;
  bottom: -5px;
} */

.ac_h_banner {
  width: 100%;
  height: clamp(100px, 25vh, 350px);
  /* height: 400px; */
  border-radius: 5px;
  overflow: hidden;
  box-sizing: border-box;
  padding: 10px;
}

.ac_h_banner > img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 5px;
}

.ac_h_bottom {
  width: 100%;
  height: auto;
  padding: 10px 0px 10px 0px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  border-bottom: solid 1px #e7e7e7;
}

.ac_h_b_typeList {
  width: 100%;
  height: auto;
  display: flex;
  flex-wrap: wrap;
  box-sizing: border-box;
  margin: 5px 0;
}

.ac_h_b_typeList > span {
  font-size: 16px;
  margin-right: 30px;
  margin-top: 10px;
  margin-bottom: 5px;
  cursor: pointer;
  /* font-weight: 600; */
}

.ac_h_b_typeList_active {
  color: #0354d7;
  position: relative;
}

/*.ac_h_b_typeList_active::after {
  content: "";
  width: 80%;
  height: 5px;
  background-color: #007aff;
  border-radius: 4px;
  position: absolute;
  top: 110%;·
  left: 10%;
}*/

.ac_h_b_selectList {
  /* margin-left: 15px; */
  margin-top: 10px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
/*
@media screen and (max-width: 1200px) {
  .ac_h_bottom{
    flex-direction: column;
  }

  .ac_h_b_typeList{
    width: 100%;
    margin-bottom: 20px;
  }

  .ac_h_b_selectList{
    width: 100%;
    display: flex;
    justify-content: flex-end;
  }
} */

.ac_content {
  width: 100%;
  height: auto;
  margin-top: 10px;
  padding-bottom: 10px;
  flex: 1;
}

.ac_c_typeCard {
  width: 100%;
  height: auto;
}

.ac_c_item,
.comItem,
.tableClass {
  width: calc(100% / 4 - (15px * 4) / 4);
  height: 225px;
  background-color: #fff;
  border-radius: 10px;
  box-sizing: border-box;
  padding: 15px;
  margin-right: 15px;
  margin-bottom: 15px;
  float: left;
  border: solid 1px #e7e7e7;
  transition: 0.2s;
  display: flex;
  flex-direction: column;
  cursor: pointer;
  .ac_c_i_top2 {
    width: 100%;
    height: 100px;
    margin-bottom: 5px;
    display: flex;
    .ac_c_i_t2_left {
      width: 62px;
      height: 62px;

      .ac_c_i_t2_l_avatarArea {
        width: 100%;
        height: 100%;
        border-radius: 2px;
        overflow: hidden;
        img {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }
        svg {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }
      }
    }
    .ac_c_i_t2_right {
      margin-left: 10px;
      width: calc(100% - 62px - 10px);
      display: flex;
      flex-direction: column;
      // justify-content: space-between;
      // align-items: ;
      .ac_c_i_t2_r_top {
        width: 100%;
        height: 30px;
        display: flex;
        // align-items: flex-start;
        justify-content: space-between;
        align-items: center;
        line-height: 30px;
        span {
          display: block;
          font-weight: bold;
          font-size: 18px;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          // max-width: calc(100% - 60px);
        }
      }

      .ac_c_i_t2_r_center {
        width: 100%;
        height: 30px;
        display: flex;
        align-items: center;
        margin-bottom: 8px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;

        span {
          font-size: 14px;
          color: #00000066;
          margin-right: 10px;
        }
      }
      .ac_c_i_t2_r_bottom {
        width: 100%;
        display: flex;
        overflow: hidden;
        &:hover {
          overflow: auto;
        }
        span {
          font-size: 14px;
          margin-right: 10px;
          padding: 4px 6px;
          background-color: #f3f7fd;
          color: #000000b8;
          font-weight: 500;
          border-radius: 4px;
          text-align: center;
          white-space: nowrap;
          img {
            width: 16px;
            height: 16px;
            position: relative;
            top: 3px;
            margin-right: 3px;
          }
        }
      }
    }
  }
  .ac_c_i_center2 {
    width: 100%;
    height: 55px;
    margin-top: 5px;
    div {
      font-size: 14px;
      color: #00000099;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2;
      overflow: hidden;
      text-overflow: ellipsis;
    }
    // background-color: yellow;
  }
  .ac_c_i_bottom2 {
    width: 100%;
    height: 30px;
    box-sizing: border-box;
    border-top: solid 1px #f3f3f3;
    display: flex;
    align-items: center;
    justify-content: space-around;
    padding-top: 15px;
    cursor: default;
    & > span {
      width: 2px;
      height: 140%;
      background-color: #f3f3f3;
    }
    div {
      display: flex;
      align-items: center;
      font-size: 12px;
      cursor: pointer;
      img {
        height: 18px;
      }
      span {
        margin-left: 5px;
        background-color: none !important;
      }
    }
  }
}

.ac_c_item,
.comItem,
.tableClass:hover {
  box-shadow: 0px 6px 30px 5px #00000015;
}

@media screen and (min-width: 2601px) {
  .ac_c_item {
    width: calc(100% / 7 - (15px * 6) / 7) !important;
  }
  .ac_c_item:nth-child(7n) {
    margin-right: 0px !important;
  }
}

@media screen and (max-width: 2600px) and (min-width: 2256px) {
  .ac_c_item {
    width: calc(100% / 6 - (15px * 5) / 6) !important;
  }
  .ac_c_item:nth-child(6n) {
    margin-right: 0px !important;
  }
}
@media screen and (max-width: 2255px) and (min-width: 1874px) {
  .ac_c_item {
    width: calc(100% / 5 - (15px * 4) / 5) !important;
  }
  .ac_c_item:nth-child(5n) {
    margin-right: 0px !important;
  }
}
@media screen and (max-width: 1873px) and (min-width: 1526px) {
  .ac_c_item {
    width: calc(100% / 4 - (15px * 3) / 4) !important;
  }
  .ac_c_item:nth-child(4n) {
    margin-right: 0px !important;
  }
}

@media screen and (max-width: 1525px) and (min-width: 1201px) {
  .ac_c_item {
    width: calc(100% / 3 - (15px * 2) / 3) !important;
  }
  .ac_c_item:nth-child(3n) {
    margin-right: 0px !important;
  }
}

@media screen and (min-width: 2701px) {
  .comItem {
    width: calc(100% / 7 - (15px * 6) / 7) !important;
  }
  .comItem:nth-child(7n) {
    margin-right: 0px !important;
  }
}

@media screen and (max-width: 2700px) and (min-width: 2356px) {
  .comItem {
    width: calc(100% / 6 - (15px * 5) / 6) !important;
  }
  .comItem:nth-child(6n) {
    margin-right: 0px !important;
  }
}
@media screen and (max-width: 2355px) and (min-width: 1974px) {
  .comItem {
    width: calc(100% / 5 - (15px * 4) / 5) !important;
  }
  .comItem:nth-child(5n) {
    margin-right: 0px !important;
  }
}
@media screen and (max-width: 1973px) and (min-width: 1201px) {
  .comItem {
    width: calc(100% / 4 - (15px * 3) / 4) !important;
  }
  .comItem:nth-child(4n) {
    margin-right: 0px !important;
  }
}

@media screen and (max-width: 1200px) {
  //and (min-width: 1201px)
  .comItem {
    width: calc(100% / 3 - (15px * 2) / 3) !important;
  }
  .comItem:nth-child(3n) {
    margin-right: 0px !important;
  }
}

/*有侧边栏的情况 */
@media screen and (min-width: 2801px) {
  .tableClass {
    width: calc(100% / 7 - (15px * 6) / 7) !important;
  }
  .tableClass:nth-child(7n) {
    margin-right: 0px !important;
  }
}

@media screen and (max-width: 2800px) and (min-width: 2456px) {
  .tableClass {
    width: calc(100% / 6 - (15px * 5) / 6) !important;
  }
  .tableClass:nth-child(6n) {
    margin-right: 0px !important;
  }
}
@media screen and (max-width: 2455px) and (min-width: 2074px) {
  .tableClass {
    width: calc(100% / 5 - (15px * 4) / 5) !important;
  }
  .tableClass:nth-child(5n) {
    margin-right: 0px !important;
  }
}
@media screen and (max-width: 2073px) and (min-width: 1401px) {
  .tableClass {
    width: calc(100% / 4 - (15px * 3) / 4) !important;
  }
  .tableClass:nth-child(4n) {
    margin-right: 0px !important;
  }
}

@media screen and (max-width: 1400px) {
  //and (min-width: 1201px)
  .tableClass {
    width: calc(100% / 3 - (15px * 2) / 3) !important;
  }
  .tableClass:nth-child(3n) {
    margin-right: 0px !important;
  }
}

.ac_c_i_t_popover {
  width: 30px;
  height: 30px;
  z-index: 3;
  position: relative;
}

.ac_c_i_t_popover svg {
  width: 30px;
  height: 30px;
  box-sizing: border-box;
  padding: 2.5px;
  cursor: pointer;
  transition: 0.3s;
  border-radius: 4px;
}

.ac_c_i_t_p_box {
  position: absolute;
  height: auto;
  top: 100%;
  right: 0;
  padding: 8px;
  border-radius: 8px 8px 8px 8px;
  background-color: #fff;
  width: auto;
  border: 1px solid #e7e7e7;
}

.ac_c_i_t_p_box > div {
  width: 100px;
  height: 30px;
  cursor: pointer;
  transition: 0.3s;
  font-size: 0.7em;
  border-radius: 5px;
  font-weight: 100;
  display: flex;
  justify-content: center;
  // padding-left: 10px;
  align-items: center;
  position: relative;
  box-sizing: border-box;
}

.ac_c_i_t_p_box > div > span {
  font-size: 15px !important;
  font-weight: 400 !important;
}

.ac_c_i_t_p_box > div > img {
  width: 18px;
  height: 18px;
  margin-right: 10px;
}

.ac_c_i_t_p_box > div:hover {
  background-color: #f2f4f7;
}

/* @media screen and (max-width: 1380px) {
	.ac_c_item {
		width: calc(100% / 4 - (15px * 3) / 4) !important;
	}

	.ac_c_item:nth-child(4n) {
		margin-right: 0px !important;
	}
} */

/* @media screen and (max-width: 1080px) {
	.ac_c_item {
		width: calc(100% / 3 - (15px * 2) / 3) !important;
	}

	.ac_c_item:nth-child(5n) {
		margin-right: 15px !important;
	}

	.ac_c_item:nth-of-type(4n) {
		margin-right: 15px !important;
	}

	.ac_c_item:nth-child(3n) {
		margin-right: 0 !important;
	}
}

@media screen and (max-width: 780px) {
	.ac_c_item {
		width: calc(100% / 2 - (15px * 2) / 2) !important;
	}

	.ac_c_item:nth-child(5n) {
		margin-right: 15px !important;
	}

	.ac_c_item:nth-of-type(4n) {
		margin-right: 15px !important;
	}

	.ac_c_item:nth-child(3n) {
		margin-right: 0 !important;
	}
} */

.ac_c_empty {
  width: 100%;
  height: 40%;
  display: flex;
  box-sizing: border-box;
  /* padding-top: 2%; */
  justify-content: center;
  color: #a1a1a1;
  div {
    width: 5vw;
    height: 5vw;
    min-width: 100px;
    min-height: 100px;
    margin-top: 50px;
    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }
  /* align-items: center; */
}

/* .ac_c_i_top {
	width: 100%;
	display: flex;
	height: calc(100% - 40px - 10px);
	cursor: pointer;
}

.ac_c_i_t_left {
	width: 64px;
	min-width: 64px;
	height: 64px;
	box-sizing: border-box;
	display: flex;
	align-items: flex-start;
	box-sizing: border-box;
	margin-right: 10px;
}

.ac_c_i_t_left > svg {
	width: 100%;
	height: 64px;
	border: 1px solid #e7e7e7;
	border-radius: 4px;
	box-sizing: border-box;
}

.ac_c_i_t_left > img {
	width: 100%;
	object-fit: cover;
	height: 64px;
	border: 1px solid #e7e7e7;
	border-radius: 4px;
	box-sizing: border-box;
}

.ac_c_i_t_right {
	flex: 1;
	width: calc(100% - 100px - 10px);
	height: 100%;
	display: flex;
	flex-direction: column;
}

.ac_c_i_t_right > div {
	width: 100%;
}

.ac_c_i_t_r_top {
	height: 30px;
	display: flex;
	align-items: flex-end;
	justify-content: space-between;
	position: relative;
	font-weight: bold;
	box-sizing: border-box;
	padding-bottom: 2px;
	line-height: 30px;
}

.ac_c_i_t_r_top > span {
	display: block;
	height: 100%;
	max-width: 100%;
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
	font-size: 18px;
}



.ac_c_i_t_r_center {
	height: 30px;
	display: flex;
	justify-content: space-between;
	align-items: center;
	margin: 0px 0 5px 0;
}

.ac_c_i_t_r_center > span {
	display: block;
	max-width: calc(100% - 80px);
	white-space: nowrap;
	overflow: hidden;
	font-size: 14px;
	color: #00000066;
	text-overflow: ellipsis;
}

.ac_c_i_t_r_center > div {
	width: 75px;
	height: 85%;
	display: flex;
	align-items: center;
	justify-content: center;
	font-size: 14px;
	background-color: #f3f3f3;
	color: #00000066;
	border-radius: 3px;
}

.ac_c_i_t_r_center > div > img {
	width: 16px;
	height: 16px;
	margin-right: 4px;
}

.ac_c_i_t_r_bottom {
	max-width: 100%;
	margin-top: 0px;
	margin-bottom: 10px;
	font-size: 16px;
	color: #00000099;
	display: -webkit-box;
	-webkit-box-orient: vertical;
	-webkit-line-clamp: 4;
	overflow: hidden;
	text-overflow: ellipsis;
	font-size: 14px;
}

.ac_c_i_bottom {
	width: 100%;
	height: 50px;
	box-sizing: border-box;
	border-top: solid 1px #e7e7e7;
	display: flex;
	align-items: center;
	justify-content: space-between;
	cursor: pointer;
}

.ac_c_i_b_left {
	width: calc(100% - 60px);
	display: flex;
	align-items: center;
	overflow: auto;
	height: 100%;
}

.ac_c_i_b_left > div {
	margin-right: 15px;
	display: flex;
	align-items: center;
}

.ac_c_i_b_left > div > img {
	width: 18px;
	height: 18px;
}

.ac_c_i_b_left > div > span {
	margin-left: 5px;
	color: #00000099;
	cursor: default;
}

.ac_c_i_b_right {
	display: flex;
	align-items: center;
	width: 70px;
	height: 75%;
	justify-content: flex-end;
}

.ac_c_i_b_right > span {
	width: 60px;
	height: 85%;
	border-radius: 4px;
	display: flex;
	justify-content: center;
	align-items: center;
	font-size: 14px;
} */

.ac_c_i_b_r_type1 {
  background-color: #ccfce3;
  color: #3ac27a;
}

.ac_c_i_b_r_type2 {
  background-color: #e6e9ff;
  color: #5c54ff;
}

.searchInputIcon {
  width: 20px;
  height: 20px;
  position: relative;
  top: 10px;
  right: 5px;
  font-size: 19px;
  cursor: pointer;
}

.ac_c_tc_item {
  width: 100%;
  height: auto;
}

.ac_c_tc_i_top {
  width: 100%;
  height: 40px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 15px;
  box-sizing: border-box;
  padding: 0 20px 0 0;
}

.ac_c_tc_i_top > div {
  font-size: 20px;
  font-weight: bold;
}

.ac_c_tc_i_top > span {
  display: flex;
  align-items: center;
  color: rgba(0, 0, 0, 0.72);
  font-size: 14px;
  cursor: pointer;
  transition: 0.3s;
  padding: 4px 10px;
  background-color: rgba(231, 231, 231, 1);
  border-radius: 20px;
  margin-top: 3px;
}

.ac_c_tc_i_top > span:hover {
  color: #3681fc;
}

.ac_c_tc_i_top > span > div {
  height: 22px;
  line-height: 21px;
}

.ac_c_tc_i_top > span > svg {
  width: 16px;
  height: 16px;
  margin-left: 5px;
  transition: 0.3s;
}

.bannerImage {
  width: 100%;
  height: clamp(100px, 25vh, 350px);
  object-fit: cover;
  border-radius: 5px;
  overflow: hidden;
  box-sizing: border-box;
}

.ac_h_banner >>> .el-carousel >>> .el-carousel__container {
  height: clamp(100px, 25vh, 350px) !important;
}
.cyban{
  height: 100%;
  font-size: 25px;
  display: flex;
  justify-content: center;
  align-items: center;
  background: #fff;
  cursor: pointer;
}
</style>